const connectionLink = process.env.REACT_APP_CONNECTION_STRING;

export default connectionLink;